import {forwardRef, useEffect, useState, useRef} from 'react';

import {Textarea as LuffyTextarea, TextareaProps as LuffyTextareaProps} from '@baidu/luffy-comp-textarea';
import classNames from 'classnames';

export declare class TextareaRef extends LuffyTextarea {}

export interface TextareaProps extends LuffyTextareaProps {
    closeBuffer?: boolean;
    onMaxLengthError?: (isError: boolean) => void;
}

const Textarea = forwardRef<LuffyTextarea, TextareaProps>((props: TextareaProps, ref) => {
    const {
        children, status,
        maxLength, defaultValue = '', value,
        onChange, onMaxLengthError,
        allowOverflow = true,
        closeBuffer,
        ...textareaProps
    } = props;

    const textareaMaxLength = maxLength;
    const [textareaStatus, setTextareaStatus] = useState(status || 'normal');
    const [textareaValue, setTextareaValue] = useState(value || defaultValue);
    const textRef: React.RefObject<TextareaRef> = useRef<TextareaRef>(null);
    const [isFocus, setIsFocus] = useState(false);


    useEffect(() => {
        if (!allowOverflow && textRef.current && maxLength) {
            textRef.current.elemTextarea.maxLength = maxLength;
        }
    }, [maxLength, allowOverflow]);

    useEffect(() => {
        const buffer = closeBuffer ? 0 : 3;
        if (onMaxLengthError) {
            onMaxLengthError(textareaStatus === 'error'
                && !!maxLength && (textareaValue.toString().length + buffer) >= maxLength
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textareaStatus]);

    useEffect(() => {
        let s = status;
        const buffer = closeBuffer ? 0 : 3;
        const str = (onChange ? value : textareaValue) || '';
        if (!!maxLength && (str.toString().length + buffer) >= maxLength) {
            s = 'error';
        } else {
            s = (status || 'normal');
        }
        if (s !== textareaStatus) {
            setTextareaStatus(s);
        }
    }, [maxLength, textareaValue, status, textareaStatus, onChange, value, closeBuffer]);

    function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
        const str = e.target.value;
        if (onChange) {
            onChange(e);
            return;
        }
        setTextareaValue(str);
    }

    const curTextareaProps = {
        ...textareaProps,
        className: classNames(
            textareaProps.className,
            isFocus && 'focus'
        ),
        onFocus: (e: React.FocusEvent<HTMLTextAreaElement>) => {
            const {onFocus} = textareaProps;
            setIsFocus(true);
            onFocus && onFocus(e);
        },
        onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => {
            const {onBlur} = textareaProps;
            setIsFocus(false);
            onBlur && onBlur(e);
        },
    };

    return (
        <LuffyTextarea
            status={textareaStatus}
            maxLength={textareaMaxLength}
            value={onChange ? value : textareaValue}
            onChange={handleChange}
            ref={ref || textRef}
            {...curTextareaProps}
        >
            {children}
        </LuffyTextarea>
    );
});

export default Textarea;
